export enum SCREEN_QUERY {
    SMALL = '(max-width: 767px)',
    MEDIUM = '(min-width: 768px) and (max-width: 1399px)',
    LARGE = '(min-width: 1400px)',
}

export const PROBLEM_WIDTH = 960;
export const BACKGROUND_WIDTH = 1920;
export const BACKGROUND_HEIGHT = 1080;
export const BACKGROUND_SIZE = {
    height: BACKGROUND_HEIGHT,
    width: BACKGROUND_WIDTH,
};
